export const MODULE = 'BILLING_BPLS';
export const UPLOAD = `${MODULE}/upload`;
export const LIST = `${MODULE}/list`;
export const UPLOAD_LIST = `${MODULE}/upload_list`;
export const SHOW_UPLOADED = `${MODULE}/show_uploaded`
export const BPLS_DOWNLOAD = "api/v1/administrators/file_uploads/{id}/download_failed";
export const DELETE_FILE_UPLOAD = "BILLINGS/delete_file_upload";
export const DELETE_FILE_HISTORY_UPLOAD = "BILLINGS/delete_file_history_upload";

